const FormSubTitle: React.FC = ({ children }) => <p className="form-note">{children}</p>;

export default FormSubTitle;
